module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAAAAXNSR0IArs4c6QAAAJdJREFUOE+l0sENgkAQheH/mViPsRVP0gUNKAk2gF14ohViPUTHLAJBdjag7vHNfsnM7ojE2ed2CqWm0sW7Ii/sUdnXzh6O4AS1GCC2QIQ/4IiM9gGZhG2Mm4dHOEVPcbxXqkOru9wOHu5gCg3ze1hLKIV/g0bxfatG0VxV/vc4wxzzeUO++B0e7rI1CxDhd7Bu5WY4ueQvXSGHST/5RPMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/rect.png
// module id = 72Cv
// module chunks = 0